import {
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { ProgressBar } from "react-bootstrap";
import Cross from "../../../Assets/Svgs/Cross";
import FIlesvg from "../../../Assets/Svgs/FIlesvg";

const documentFields = [
  { id: "offer-letter", name: "doc_offerLetter", label: "Offer Letter" },
  {
    id: "relieving-Letter",
    name: "doc_relievingLetter",
    label: "Relieving Letter",
  },
  {
    id: "experience-Letter",
    name: "doc_experienceLetter",
    label: "Experience Letter",
  },
  { id: "salary-Slip", name: "doc_salarySlip", label: "Salary Slip" },
];

const Experince = ({
  userportaldata,
  handleChange,
  handleDateChange,
  handleAddExperience,
  handleRemoveExperience,
  experince,
  id,
  experienceFields,
  errors,
  Percente,
  handleRemovefile,
}) => {
  return (
    <Stack
      direction={"column"}
      sx={{
        display: experince === false ? "none" : "flex",
        gap: "20px",
        height: "100%",
        borderBottom:
          experienceFields === 1 || experince === false ? "" : "2px solid #ccc",
      }}
    >
      <Stack direction={"column"}>
        {experince && (
          <Stack
            direction={"column"}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: "15px",
              padding: "10px 0px 25px 0px",
            }}
          >
            <Stack direction={"column"}>
              <Typography
                component={"span"}
                variant="caption"
                sx={{
                  fontSize: "15px",
                  fontWeight: "500",
                  color: "black",
                }}
              >
                Company Name:
              </Typography>
              <input
                type="text"
                name="comp_name"
                value={userportaldata?.comp_name || ""}
                onChange={(e) => handleChange(e, id)}
                className="form-control"
                placeholder="Enter Company Name"
                style={{
                  height: "40px",
                  width: "100%",
                  maxWidth: "500px",
                  padding: "8px 12px",
                  borderRadius: "4px",
                  border: errors?.[`${id}.comp_name`]
                    ? "1px solid red"
                    : "1px solid #ccc",
                  marginBottom: errors?.[`${id}.comp_name`] ? "0px" : "",
                }}
              />
              {errors?.[`${id}.comp_name`] && (
                <FormHelperText error>
                  {errors?.[`${id}.comp_name`]}
                </FormHelperText>
              )}
            </Stack>
            <Stack
              direction={"column"}
              sx={{ gap: errors?.[`${id}.Exp_years`] ? "0px" : "7px" }}
            >
              <Typography
                component={"span"}
                variant="caption"
                sx={{
                  fontSize: "15px",
                  fontWeight: "500",
                  color: "black",
                }}
              >
                Total Experience:
              </Typography>
              <FormControl
                sx={{
                  width: { xs: "100%", sm: "100%", md: "50%", lg: "40%" },
                  margin: "0px",
                }}
                size="small"
              >
                <InputLabel id="experience-label" sx={{ fontSize: "14px" }}>
                  Select Years
                </InputLabel>
                <Select
                  labelId="experience-label"
                  name="Exp_years"
                  value={userportaldata?.Exp_years || ""}
                  label="Experience"
                  onChange={(e) => handleChange(e, id)}
                  sx={{
                    borderRadius: "4px",
                    backgroundColor: "#fff",
                  }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={"less_than_1"}>Less than 1 year</MenuItem>
                  {[...Array(10)].map((_, i) => (
                    <MenuItem key={i + 1} value={i + 1}>
                      {i + 1} Year{i + 1 > 1 ? "s" : ""}
                    </MenuItem>
                  ))}
                  <MenuItem value={"more_than_10"}>More than 10 years</MenuItem>
                </Select>
              </FormControl>
              {errors?.[`${id}.Exp_years`] && (
                <FormHelperText error>
                  {errors?.[`${id}.Exp_years`]}
                </FormHelperText>
              )}
            </Stack>

            <Stack direction={"column"}>
              <Typography
                component={"span"}
                variant="caption"
                sx={{
                  fontSize: "15px",
                  fontWeight: "500",
                  color: "black",
                }}
              >
                Job Description:
              </Typography>
              <textarea
                name="description"
                className="form-control"
                rows="4"
                placeholder="Describe your role and responsibilities..."
                value={userportaldata.description || ""}
                onChange={(e) => handleChange(e, id)}
                style={{
                  width: "100%",
                  maxWidth: "500px",
                  padding: "8px 12px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  fontSize: "14px",
                  resize: "vertical",
                }}
              ></textarea>
            </Stack>
            <Stack direction={"column"} gap={"20px"}>
              <Stack sx={{ width: "100%" }}>
                <Typography
                  component={"span"}
                  variant="caption"
                  sx={{
                    fontSize: "15px",
                    fontWeight: "500",
                    color: "black",
                  }}
                >
                  Date of Joining:
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format="DD/MM/YYYY"
                    maxDate={dayjs()}
                    value={
                      userportaldata.doj
                        ? dayjs(userportaldata.doj, "DD/MM/YYYY")
                        : null
                    }
                    onChange={(newValue) => handleDateChange(newValue, "doj")}
                    sx={{
                      // pb: "22px",
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "30%",
                        lg: "40%",
                      },
                      label: { fontSize: "13px !important" },
                    }}
                  />
                </LocalizationProvider>
                {errors?.[`${id}.doj`] && (
                  <FormHelperText error>{errors?.[`${id}.doj`]}</FormHelperText>
                )}
              </Stack>
              <Stack sx={{ width: "100%" }}>
                <Typography
                  component={"span"}
                  variant="caption"
                  sx={{
                    fontSize: "15px",
                    fontWeight: "500",
                    color: "black",
                  }}
                >
                  Date of Exit:
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format="DD/MM/YYYY"
                    maxDate={dayjs()}
                    value={
                      userportaldata.doe
                        ? dayjs(userportaldata.doe, "DD/MM/YYYY")
                        : null
                    }
                    onChange={(newValue) => handleDateChange(newValue, "doe")}
                    sx={{
                      // pb: "22px",
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "30%",
                        lg: "40%",
                      },
                      label: { fontSize: "13px !important" },
                    }}
                  />
                </LocalizationProvider>
                {errors?.[`${id}.doe`] && (
                  <FormHelperText error>{errors?.[`${id}.doe`]}</FormHelperText>
                )}
              </Stack>
            </Stack>
            <Stack direction={"column"} gap={"10px"}>
              {documentFields.map((doc, i) => (
                <Stack
                  key={doc.id || i}
                  direction={"row"}
                  gap={"10px"}
                  alignItems={"center"}
                >
                  <Typography
                    component={"span"}
                    variant="caption"
                    sx={{
                      fontSize: "15px",
                      fontWeight: "500",
                      color: "black",
                      width: "150px",
                    }}
                  >
                    {doc.name === "doc_salarySlip" ? (
                      <>Salary Slip (min 3)</>
                    ) : (
                      doc.label
                    )}
                  </Typography>

                  <Stack
                    direction={"row"}
                    alignItems={"center"}
                    className="progressBar_Verificationportal_sam"
                    sx={{ width: window.innerWidth < 600 ? "68%" : "60%" }}
                  >
                    {userportaldata.id === id &&
                      (userportaldata[doc.name] &&
                      userportaldata[doc.name].length > 0 ? (
                        <>
                          {doc.name !== "doc_salarySlip" &&
                          Array.isArray(userportaldata[doc.name]) &&
                          userportaldata[doc.name][0] === false ? (
                            <>
                              {Percente[`${id}_${doc.name}_progress`] > 1 ? (
                                <>
                                  {Percente[`${id}_${doc.name}_progress`] >
                                    1 && (
                                    <ProgressBar
                                      animated
                                      now={
                                        Percente[`${id}_${doc.name}_progress`]
                                      }
                                      label={
                                        Percente[`${id}_${doc.name}_progress`] +
                                        "%"
                                      }
                                      style={{
                                        width:
                                          window.innerWidth > 800
                                            ? "50%"
                                            : "100%",
                                      }}
                                    />
                                  )}

                                  {errors?.[`${id}.${doc.name}`] && (
                                    <FormHelperText error>
                                      {errors?.[`${id}.${doc.name}`]}
                                    </FormHelperText>
                                  )}
                                </>
                              ) : (
                                <>
                                  <input
                                    type="file"
                                    id={`${doc.id}-${id}`}
                                    name={doc.name}
                                    style={{ display: "none" }}
                                    onChange={(e) => handleChange(e, id)}
                                  />
                                  <label htmlFor={`${doc.id}-${id}`}>
                                    <Button
                                      variant="contained"
                                      component="span"
                                      className="btn-light"
                                      sx={{
                                        padding: "3px 16px !important",
                                        height: "40px",
                                        fontSize: {
                                          xs: "10px !important",
                                          sm: "10px !important",
                                          md: "13px !important",
                                          lg: "13px !important",
                                        },
                                        minWidth: "120px",
                                        ":hover": {
                                          padding: "3px 16px !important",
                                          fontSize: "13px !important",
                                          height: "40px",
                                        },
                                      }}
                                    >
                                      Upload File
                                    </Button>
                                  </label>
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              {doc.name === "doc_salarySlip" ? (
                                <>
                                  <>
                                    {(() => {
                                      let validFiles = Array.isArray(
                                        userportaldata[doc.name]
                                      )
                                        ? [...userportaldata[doc.name]]
                                        : [];
                                      return (
                                        <>
                                          {validFiles
                                            .slice(0, 3)
                                            .map((item, index) => {
                                              return (
                                                item !== false && (
                                                  <Stack
                                                    key={`${userportaldata.id}-${index}`}
                                                  >
                                                    <Tooltip
                                                      sx={{
                                                        height: "0px",
                                                        width: "0px",
                                                        margin:
                                                          "3px 0px -4px 26px",
                                                      }}
                                                    >
                                                      <IconButton
                                                        onClick={() =>
                                                          handleRemovefile(
                                                            doc.name,
                                                            id,
                                                            index
                                                          )
                                                        }
                                                      >
                                                        <Cross />
                                                      </IconButton>
                                                    </Tooltip>
                                                    <FIlesvg />
                                                  </Stack>
                                                )
                                              );
                                            })}
                                          {(validFiles.length < 3 ||
                                            validFiles
                                              .slice(0, 3)
                                              .includes(false)) &&
                                          !(
                                            Percente[
                                              `${id}_${doc.name}_progress`
                                            ] > 1
                                          ) ? (
                                            <>
                                              <input
                                                type="file"
                                                id={`${doc.id}-${id}`}
                                                name={doc.name}
                                                style={{ display: "none" }}
                                                onChange={(e) =>
                                                  handleChange(e, id)
                                                }
                                              />
                                              <label
                                                htmlFor={`${doc.id}-${id}`}
                                              >
                                                <Button
                                                  variant="contained"
                                                  component="span"
                                                  className="btn-light"
                                                  sx={{
                                                    padding:
                                                      "3px 16px !important",
                                                    height: "40px",
                                                    fontSize: {
                                                      xs: "10px !important",
                                                      sm: "10px !important",
                                                      md: "13px !important",
                                                      lg: "13px !important",
                                                    },
                                                    minWidth: "120px",
                                                    ":hover": {
                                                      padding:
                                                        "3px 16px !important",
                                                      fontSize:
                                                        "13px !important",
                                                      height: "40px",
                                                    },
                                                  }}
                                                >
                                                  Upload File
                                                </Button>
                                              </label>
                                              {Percente[
                                                `${id}_${doc.name}_progress`
                                              ] > 1 && (
                                                <ProgressBar
                                                  animated
                                                  now={
                                                    Percente[
                                                      `${id}_${doc.name}_progress`
                                                    ]
                                                  }
                                                  label={
                                                    Percente[
                                                      `${id}_${doc.name}_progress`
                                                    ] + "%"
                                                  }
                                                  style={{
                                                    width:
                                                      window.innerWidth > 800
                                                        ? "50%"
                                                        : "100%",
                                                  }}
                                                />
                                              )}

                                              {errors?.[
                                                `${id}.${doc.name}`
                                              ] && (
                                                <FormHelperText error>
                                                  {
                                                    errors?.[
                                                      `${id}.${doc.name}`
                                                    ]
                                                  }
                                                </FormHelperText>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {Percente[
                                                `${id}_${doc.name}_progress`
                                              ] > 1 && (
                                                <ProgressBar
                                                  animated
                                                  now={
                                                    Percente[
                                                      `${id}_${doc.name}_progress`
                                                    ]
                                                  }
                                                  label={
                                                    Percente[
                                                      `${id}_${doc.name}_progress`
                                                    ] + "%"
                                                  }
                                                  style={{
                                                    width:
                                                      window.innerWidth > 800
                                                        ? "50%"
                                                        : "100%",
                                                  }}
                                                />
                                              )}
                                            </>
                                          )}
                                        </>
                                      );
                                    })()}
                                  </>
                                </>
                              ) : (
                                <Stack key={userportaldata.id}>
                                  <Tooltip
                                    sx={{
                                      height: "0px",
                                      width: "0px",
                                      margin: "3px 0px -4px 26px",
                                    }}
                                  >
                                    <IconButton
                                      onClick={() =>
                                        handleRemovefile(doc.name, id)
                                      }
                                    >
                                      <Cross />
                                    </IconButton>
                                  </Tooltip>
                                  <FIlesvg />
                                </Stack>
                              )}
                            </>
                          )}{" "}
                        </>
                      ) : (
                        <>
                          {doc.name === "doc_salarySlip" ? (
                            <>
                              {Percente[`${id}_${doc.name}_progress`] > 1 ? (
                                <>
                                  {Percente[`${id}_${doc.name}_progress`] >
                                    1 && (
                                    <ProgressBar
                                      animated
                                      now={
                                        Percente[`${id}_${doc.name}_progress`]
                                      }
                                      label={
                                        Percente[`${id}_${doc.name}_progress`] +
                                        "%"
                                      }
                                      style={{
                                        width:
                                          window.innerWidth > 800
                                            ? "50%"
                                            : "100%",
                                      }}
                                    />
                                  )}
                                </>
                              ) : (
                                <>
                                  <input
                                    type="file"
                                    id={`${doc.id}-${id}`}
                                    name={doc.name}
                                    style={{ display: "none" }}
                                    onChange={(e) => handleChange(e, id)}
                                  />
                                  <label htmlFor={`${doc.id}-${id}`}>
                                    <Button
                                      variant="contained"
                                      component="span"
                                      className="btn-light"
                                      sx={{
                                        padding: "3px 16px !important",
                                        height: "40px",
                                        fontSize: {
                                          xs: "10px !important",
                                          sm: "10px !important",
                                          md: "13px !important",
                                          lg: "13px !important",
                                        },
                                        minWidth: "120px",
                                        ":hover": {
                                          padding: "3px 16px !important",
                                          fontSize: "13px !important",
                                          height: "40px",
                                        },
                                      }}
                                    >
                                      Upload File
                                    </Button>
                                  </label>

                                  {errors?.[`${id}.${doc.name}`] && (
                                    <FormHelperText error>
                                      {errors?.[`${id}.${doc.name}`]}
                                    </FormHelperText>
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              {Percente[`${id}_${doc.name}_progress`] > 1 ? (
                                <>
                                  {Percente[`${id}_${doc.name}_progress`] >
                                    1 && (
                                    <ProgressBar
                                      animated
                                      now={
                                        Percente[`${id}_${doc.name}_progress`]
                                      }
                                      label={
                                        Percente[`${id}_${doc.name}_progress`] +
                                        "%"
                                      }
                                      style={{
                                        width:
                                          window.innerWidth > 800
                                            ? "50%"
                                            : "100%",
                                      }}
                                    />
                                  )}

                                  {errors?.[`${id}.${doc.name}`] && (
                                    <FormHelperText error>
                                      {errors?.[`${id}.${doc.name}`]}
                                    </FormHelperText>
                                  )}
                                </>
                              ) : (
                                <>
                                  <input
                                    type="file"
                                    id={`${doc.id}-${id}`}
                                    name={doc.name}
                                    style={{ display: "none" }}
                                    onChange={(e) => handleChange(e, id)}
                                  />
                                  <label htmlFor={`${doc.id}-${id}`}>
                                    <Button
                                      variant="contained"
                                      component="span"
                                      className="btn-light"
                                      sx={{
                                        padding: "3px 16px !important",
                                        height: "40px",
                                        fontSize: {
                                          xs: "10px !important",
                                          sm: "10px !important",
                                          md: "13px !important",
                                          lg: "13px !important",
                                        },
                                        minWidth: "120px",
                                        ":hover": {
                                          padding: "3px 16px !important",
                                          fontSize: "13px !important",
                                          height: "40px",
                                        },
                                      }}
                                    >
                                      Upload File
                                    </Button>
                                  </label>
                                </>
                              )}
                            </>
                          )}
                        </>
                      ))}
                  </Stack>
                </Stack>
              ))}
            </Stack>
            <Stack direction="row" spacing={2} sx={{ mt: 1 }}>
              {experienceFields === 1 ? (
                <Button
                  variant="outlined"
                  onClick={handleAddExperience}
                  className="btn-light"
                  sx={{
                    padding: "3px 16px !important",
                    height: "40px",
                    fontSize: {
                      xs: "10px !important",
                      sm: "10px !important",
                      md: "13px !important",
                      lg: "13px !important",
                    },
                    minWidth: "120px",
                    ":hover": {
                      padding: "3px 16px !important",
                      fontSize: "13px !important",
                      height: "40px",
                    },
                  }}
                >
                  Add More Experience
                </Button>
              ) : (
                <Button
                  variant="outlined"
                  color="error"
                  className="btn-light"
                  onClick={() => handleRemoveExperience(id)}
                  sx={{
                    padding: "3px 16px !important",
                    height: "40px",
                    fontSize: {
                      xs: "10px !important",
                      sm: "10px !important",
                      md: "13px !important",
                      lg: "13px !important",
                    },
                    minWidth: "120px",
                    ":hover": {
                      padding: "3px 16px !important",
                      fontSize: "13px !important",
                      height: "40px",
                    },
                  }}
                >
                  Remove
                </Button>
              )}
            </Stack>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default Experince;
